export const ITR_updateJourneyTypeEnumReducer = {
  ITR_updateJourneyTypeEnum: (state, action) => {
    state.journeyTypeEnum = action.payload;
  },
};
